/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var XIcon16Light = forwardRef('XIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M3.145 3.148a.5.5 0 0 1 .707 0l3.645 3.645 3.646-3.645a.5.5 0 1 1 .707.707L8.205 7.5l3.645 3.645a.5.5 0 1 1-.707.707L7.497 8.207l-3.645 3.645a.5.5 0 1 1-.707-.707L6.79 7.5 3.145 3.855a.5.5 0 0 1 0-.707Z" })));
});
